import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CardNextStepComponent } from '../card-next-step.component';
import { GtmService } from '../../../services/gtm.service';
import { ToolPreautorisationService } from '../../../../tool-preautorisation/tool-preautorisation.service';

@Component({
  selector: 'app-card-next-step-compact',
  templateUrl: '../card-next-step.component.html',
  styleUrls: ['./card-next-step-compact.component.scss'],
  standalone: false
})
export class CardNextStepCompactComponent extends CardNextStepComponent implements OnInit {
  constructor(_router: Router, _gtm: GtmService, _toolPreautorisationService: ToolPreautorisationService) {
    super(_router, _gtm, _toolPreautorisationService);
  }

  ngOnInit() {
    super.ngOnInit();
  }
}
